import React, { useState, useEffect, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faTimes,
    faChevronLeft,
    faChevronRight,
    faExternalLinkAlt,
} from '@fortawesome/free-solid-svg-icons'

import TabPageItem from './pagesTabItem'

const ArrowButtonLeft = ({ icon, handleClick }) => (
    <button
        className="flex-none p-2 w-10 text-center border-r border-gray-400 focus:outline-none cursor-pointer"
        onClick={handleClick}
    >
        <FontAwesomeIcon icon={icon} size="lg" />
    </button>
)

const ArrowButtonRight = ({ icon, handleClick }) => (
    <button
        className="flex-none p-2 w-10 text-center border-l border-gray-400 focus:outline-none cursor-pointer"
        onClick={handleClick}
    >
        <FontAwesomeIcon icon={icon} size="lg" />
    </button>
)

const CloseAllButton = ({ handleCloseAll }) => (
    <div
        className="flex-none p-2 w-10 text-center bg-gray-700 border-r border-gray-500 cursor-pointer"
        onClick={e => {
            e.preventDefault()
            handleCloseAll()
        }}
    >
        <FontAwesomeIcon icon={faTimes} size="lg" />
    </div>
)

const NewOpenButton = ({ handleOpenNewTab }) => (
    <div
        className="flex-none p-2 w-10 text-center bg-gray-700 cursor-pointer"
        onClick={e => {
            e.preventDefault()
            handleOpenNewTab()
        }}
    >
        <FontAwesomeIcon icon={faExternalLinkAlt} size="lg" />
    </div>
)

export default props => {
    const { pages, currentPageId, handleChangeChild, handleCloseAll, handleOpenNewTab } = props
    const tabContainer = useRef(null)
    const currentLeft = useRef(0)

    const setContainerLeft = left => {
        currentLeft.current = left
        if (tabContainer.current) {
            tabContainer.current.parentElement.scrollLeft = left
        }
    }

    const handleMoveLeft = e => {
        e.preventDefault()
        setContainerLeft(currentLeft.current > 200 ? currentLeft.current - 200 : 0)
    }
    const handleMoveRight = e => {
        e.preventDefault()
        const { current } = tabContainer

        let containerWidth = 0
        for (const child of current.childNodes) {
            containerWidth = child.offsetLeft + child.offsetWidth
        }
        setContainerLeft(
            currentLeft.current + 200 + current.parentElement.offsetWidth > containerWidth
                ? containerWidth - current.parentElement.offsetWidth
                : currentLeft.current + 200
        )
    }
    const flagMoveBtn = true

    //TODO :미세하게 조절 필요
    const getScrollLeft4Active = left => {
        const { current } = tabContainer
        let containerWidth = 0
        let activeLeft, activeWidth

        for (const child of current.childNodes) {
            containerWidth = child.offsetLeft + child.offsetWidth
            if (child.id === 'active') {
                activeLeft = child.offsetLeft
                activeWidth = child.offsetWidth
            }
        }
        if (activeLeft + activeWidth > current.parentElement.offsetWidth) {
            left = activeLeft + activeWidth - current.parentElement.offsetWidth
        }
        if (activeLeft < left) {
            left = activeLeft
        }
        return left
    }

    useEffect(() => {
        setTimeout(() => {
            const { current } = tabContainer
            if (current) {
                setContainerLeft(getScrollLeft4Active(currentLeft.current))
                // const left = getScrollLeft4Active(currentLeft.current)
                // currentLeft.current = left
                // current.parentElement.scrollLeft = left
            }
        }, 10)
    }, [pages])

    return (
        <div className="flex-none hidden md:block bg-gray-500 w-full text-white h-10">
            <div className="flex flex-row">
                {flagMoveBtn && (
                    <ArrowButtonLeft icon={faChevronLeft} handleClick={handleMoveLeft} />
                )}
                <div className="flex-grow overflow-hidden">
                    <div
                        ref={tabContainer}
                        className="flex flex-row"
                        style={{ width: '20000px', fontFamily: 'Nanum Gothic' }}
                    >
                        {pages.map((obj, key) => {
                            const tabprops = { key, ...obj, currentPageId, handleChangeChild }
                            return <TabPageItem {...tabprops} />
                        })}
                    </div>
                </div>
                {flagMoveBtn && (
                    <ArrowButtonRight icon={faChevronRight} handleClick={handleMoveRight} />
                )}
                <CloseAllButton handleCloseAll={handleCloseAll} />
                <NewOpenButton handleOpenNewTab={handleOpenNewTab} />
            </div>
        </div>
    )
}
